// extracted by mini-css-extract-plugin
export default {"socialBlock":"SocialBlock_socialBlock__m5vDJ","socialBlockIcon":"SocialBlock_socialBlockIcon__jpuHM"};